<template>
  <section class="cstcloud-page">
    <article class="cstcloud-card cstcloud-form-card">
      <div class="cstcloud-brand"><span>CST</span> 中国科技云</div>
      <h1>绑定已有本站账号</h1>
      <p class="cstcloud-lead">为保护原有会员、缴费和会议数据，请再次验证本站账号。系统不会仅凭相同邮箱自动合并。</p>
      <div v-if="expired" class="service-notice warning">本次办理凭据已失效，请重新发起科技云登录。</div>
      <form v-else class="cstcloud-form single" @submit.prevent="submit">
        <div class="cstcloud-method-tabs">
          <button type="button" :class="{ active: method === 'PASSWORD' }" @click="method = 'PASSWORD'">密码验证</button>
          <button type="button" :class="{ active: method === 'EMAIL_CODE' }" @click="method = 'EMAIL_CODE'">邮箱验证码</button>
        </div>
        <label>已有账号邮箱 <em>*</em><input v-model.trim="email" type="email" autocomplete="username" /></label>
        <template v-if="method === 'PASSWORD'">
          <label>本站登录密码 <em>*</em><input v-model="password" type="password" autocomplete="current-password" /></label>
          <slide-captcha :request="slideRequest" @ticket="slideTicket = $event" />
        </template>
        <div v-else class="cstcloud-code-field">
          <label>邮箱验证码 <em>*</em><input v-model.trim="verificationCode" inputmode="numeric" maxlength="6" /></label>
          <button type="button" class="ghost-action compact" :disabled="codeSending || codeSeconds > 0" @click="sendCode">{{ codeButtonText }}</button>
        </div>
        <p v-if="feedback" class="service-notice" :class="{ warning: failed }" role="alert">{{ feedback }}</p>
        <div class="cstcloud-actions">
          <button type="submit" class="primary-action" :disabled="submitting">{{ submitting ? '正在验证...' : '验证并绑定' }}</button>
          <button type="button" class="ghost-action" @click="$router.push('/auth/cstcloud/onboarding')">创建新账号</button>
        </div>
      </form>
    </article>
  </section>
</template>

<script>
import SlideCaptcha from '../../components/auth/SlideCaptcha.vue'
import { bindExistingCstCloudUser, issueSlideCaptcha, saveToken, sendEmailCode, verifySlideCaptcha } from '../../api/paleo'
import { clearOnboardingFlow, readOnboardingFlow, safeRedirectPath, unwrapApiData } from '../../utils/cstCloudAuth'

export default {
  name: 'CstCloudBindExistingPage',
  components: { SlideCaptcha },
  inject: ['front'],
  data() { return { flow: null, expired: false, method: 'PASSWORD', email: '', password: '', verificationCode: '', slideTicket: '', submitting: false, codeSending: false, codeSeconds: 0, codeTimer: null, feedback: '', failed: false } },
  computed: { codeButtonText() { return this.codeSeconds > 0 ? `${this.codeSeconds}s 后重发` : (this.codeSending ? '发送中...' : '获取验证码') } },
  created() {
    this.flow = readOnboardingFlow()
    if (!this.flow) { this.expired = true; return }
    this.email = (this.flow.profile && this.flow.profile.email) || ''
  },
  beforeDestroy() { if (this.codeTimer) clearInterval(this.codeTimer) },
  methods: {
    validEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) },
    async slideRequest(options) { return options.method === 'GET' ? issueSlideCaptcha() : verifySlideCaptcha(options.body) },
    async sendCode() {
      if (!this.validEmail(this.email)) { this.showError('请先填写正确的已有账号邮箱'); return }
      this.codeSending = true
      try {
        await sendEmailCode(this.email.toLowerCase(), 'CSTCLOUD_BIND')
        this.feedback = '验证码已发送，请查收邮箱'; this.failed = false; this.codeSeconds = 60
        this.codeTimer = setInterval(() => { this.codeSeconds -= 1; if (this.codeSeconds <= 0) { clearInterval(this.codeTimer); this.codeTimer = null } }, 1000)
      } catch (error) { this.showError(error.message || '验证码发送失败') } finally { this.codeSending = false }
    },
    async submit() {
      if (this.submitting) return
      if (!this.validEmail(this.email)) { this.showError('请填写正确的已有账号邮箱'); return }
      if (this.method === 'PASSWORD' && (!this.password || !this.slideTicket)) { this.showError('请填写密码并完成滑动验证'); return }
      if (this.method === 'EMAIL_CODE' && !/^\d{6}$/.test(this.verificationCode)) { this.showError('请输入 6 位邮箱验证码'); return }
      this.submitting = true
      try {
        const data = unwrapApiData(await bindExistingCstCloudUser({ onboardingTicket: this.flow.onboardingTicket, verificationType: this.method, email: this.email.toLowerCase(), password: this.method === 'PASSWORD' ? this.password : undefined, slideTicket: this.method === 'PASSWORD' ? this.slideTicket : undefined, verificationCode: this.method === 'EMAIL_CODE' ? this.verificationCode : undefined }))
        if (!data.token) throw new Error('绑定已完成，但登录凭证签发失败，请重新登录')
        clearOnboardingFlow(); saveToken(data.token); this.front.isLoggedIn = true; this.front.applyMembershipSession(data)
        await this.front.loadSelfService()
        await this.$router.replace(safeRedirectPath(data.redirectPath || this.flow.redirectPath, '/')).catch(() => {})
      } catch (error) { this.showError(error.message || '账号验证或绑定失败') } finally { this.submitting = false }
    },
    showError(message) { this.feedback = message; this.failed = true }
  }
}
</script>
